import { Component, HostListener, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-web-header',
  templateUrl: './web-header.component.html',
  styleUrls: ['./web-header.component.css']
})
export class WebHeaderComponent implements OnInit {
  @HostListener('window:scroll', [])
  onWindowScroll() { this.isSticky = window.scrollY > 50; }

  isSticky = false;
  language:any;
  languageChange = new FormControl('');
  languageArray = ["English", "Marathi" , "Hindi"];

  constructor( 
    public translate: TranslateService,
    private config: ConfigService
  ) { }
 
  ngOnInit(): void {
    this.changeLanguage(localStorage.getItem('language') ? localStorage.getItem('language') : 'Marathi');
  }
 
  changeLanguage(lang?: any) {
    this.languageChange.setValue(lang);
    this.language = lang ? lang : 'Marathi';
    this.config.setLanguage.next(this.language);
    localStorage.setItem('language', lang);
    this.translate.use(this.language);
    }

  closeMobileMenu() {
    const navbar = document.querySelector('.navbar-collapse');
    if (navbar && navbar?.classList?.contains('show')) {
      navbar?.classList?.remove('show'); // Hide the menu
    }
  }

}
